/*
 * wall-dimension-inputs.js — whole feet only in every wall-size "ft" box.
 *
 * A wall is entered as feet + inches (8' 6"), so a fraction of a foot belongs in
 * the inches box. Left alone, a number box happily takes "8.5" in the feet box,
 * and the configurators read it with parseFloat as 8' 6" — a second, hidden way
 * to say the same thing that the shopper never sees spelled out.
 *
 * Covers:
 *   1. the PDP buy-box card        (#bb-width-feet, #bb-height-feet)
 *   2. the editor/configurator     (#width-feet, #height-feet)
 *   3. the custom sample editor    (same ids as the editor)
 *   4. the large-file upload form  (#wall-width-feet, #wall-height-feet)
 *
 * Inches boxes are untouched: a decimal is still allowed there, and no host
 * writes a trailing ".0" into them.
 *
 * Listeners are delegated on document in the capture phase, so they run before
 * each host's own input handlers read the value, and they cover markup that
 * renders late.
 */
(function () {
  if (window.ACWallDimInputs) return;
  window.ACWallDimInputs = true;

  var FEET = [
    '#width-feet', '#height-feet',
    '#bb-width-feet', '#bb-height-feet',
    '#wall-width-feet', '#wall-height-feet'
  ].join(',');

  function isFeet(el) {
    return !!(el && el.tagName === 'INPUT' && el.matches && el.matches(FEET));
  }

  // Digits-only keypad on phones, and a whole-number step for the spinner.
  function prep(el) {
    if (el.__acWholeFeet) return;
    el.__acWholeFeet = true;
    el.step = '1';
    el.setAttribute('inputmode', 'numeric');
    el.setAttribute('pattern', '[0-9]*');
  }

  function prepAll() {
    Array.prototype.forEach.call(document.querySelectorAll(FEET), prep);
  }

  // Keep only the whole-feet part of anything that got in (a paste of "8.5").
  function wholeFeet(el) {
    var v = String(el.value);
    if (v === '' || /^\d+$/.test(v)) return;
    var n = Math.floor(Math.abs(parseFloat(v)));
    el.value = isNaN(n) ? '' : String(n);
  }

  // Block ".", ",", "e", "+", "-" as they are typed.
  document.addEventListener('keydown', function (e) {
    if (!isFeet(e.target) || e.ctrlKey || e.metaKey || e.altKey) return;
    if (e.key && e.key.length === 1 && !/[0-9]/.test(e.key)) e.preventDefault();
  }, true);

  // Same rule for soft keyboards, which often report keydown as "Unidentified".
  // Multi-character inserts (paste, drop, autofill, dictation) go through and
  // are trimmed to whole feet on input, so "8.5" becomes 8 rather than nothing.
  document.addEventListener('beforeinput', function (e) {
    if (!isFeet(e.target) || e.data == null || e.data.length !== 1) return;
    if (/[^0-9]/.test(e.data)) e.preventDefault();
  }, true);

  document.addEventListener('input', function (e) {
    if (isFeet(e.target)) wholeFeet(e.target);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (isFeet(e.target)) prep(e.target);
  }, true);

  // Some browsers show "8." while reporting the value as "8". Repaint on the way
  // out so the box shows exactly the number that counts.
  document.addEventListener('focusout', function (e) {
    var el = e.target;
    if (!isFeet(el)) return;
    wholeFeet(el);
    var v = el.value;
    if (v !== '') { el.value = ''; el.value = v; }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepAll);
  } else {
    prepAll();
  }
  // The buy box and the editors can render late on some templates.
  setTimeout(prepAll, 600);
  setTimeout(prepAll, 1500);
})();
